module.exports = __webpack_public_path__ + "static/media/AgentServiceAuto.0edcf5d6.svg";